import { render, staticRenderFns } from "./MenuSkeleton.vue?vue&type=template&id=e934b22e&"
import script from "./MenuSkeleton.vue?vue&type=script&lang=js&"
export * from "./MenuSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports